export const ErpDocumentationMap = {
  webhookOrder: {
    url: 'https://suppliererp.com/order',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      API_KEY: 'api-key-sent-to-supplier',
    },
    body: {
      reference: {
        supplier_id: 'CNPJ',
        order_id: '1234',
        created_date: '2022-07-02T01:19:05-03:00',
        observation: '',
        status: 'SHIPPED',
      },
      shipping: {
        responsible: 'Inventa',
        receiver_name: 'Felipe',
        address: {
          address: 'Rua Marlo da Costa e Souza, 185',
          city: 'Rio de Janeiro',
          state: 'RJ',
          country: 'BR',
          zip_code: '22790-735',
          additional_info: 'ap 1103 bloco 1',
          reference: 'ap 1103 bloco 1',
        },
      },
      payment: {
        total_amount: 376.33,
      },
      customer: {
        name: 'Felipe',
        document_number: '44426322000172',
      },
      products: [
        {
          sku: '210094',
          name: 'Produdo um',
          quantity: 1.0,
          price: 47.74,
          shipping_cost: 0.0,
        },
        {
          sku: '210094',
          name: 'Produto dois',
          quantity: 1.0,
          price: 47.74,
          shipping_cost: 0.0,
        },
      ],
    },
  },
  productUpdate: {
    url: 'https://integration.inventa.tec.br/products/product-sku/',
    mehtod: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Auth: 'api-key-sent-to-supplier',
    },
    body: {
      stock: 80,
      status: 'ACTIVE',
      supplier_id: ['cnpj'],
    },
  },
  batchProductUpdate: {
    url: 'https://integration.inventa.tec.br/products/',
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Auth: 'api-key-sent-to-supplier',
    },
    body: {
      supplier_id: ['cnpj'],
      products: [
        {
          stock: 99,
          status: 'INACTIVE',
          sku: 'product-sku',
        },
        {
          stock: 99,
          status: 'ACTIVE',
          sku: 'product-sku2',
        },
        {
          stock: 99,
          sku: 'product-sku2',
        },
      ],
    },
  },
  orderUpdate: {
    url: 'https://integration.inventa.tec.br/api/orders/order-id(24312)',
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Auth: 'api-key-sent-to-supplier',
    },
    body: {
      reference: {
        status: 'SHIPPED',
        supplier_id: 'CNPJ',
      },
      shipping: {
        date: '',
        tracking: {
          company: '',
          number: '',
        },
      },
      invoice: {
        danfe: 'base64(string)',
        nf_xml: 'xml(string)',
      },
    },
  },
  batchOrderUpdate: {
    url: 'https://integration.inventa.tec.br/orders/',
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Auth: 'api-key-sent-to-supplier',
    },
    body: [
      {
        reference: {
          order_id: '2352',
          status: 'SHIPPED',
          supplier_id: 'CNPJ',
        },
        shipping: {
          date: '',
          tracking: {
            company: '',
            number: '',
          },
        },
        invoice: {
          danfe: 'base64(string)',
          nf_xml: 'xml(string)',
        },
      },
      {
        reference: {
          order_id: '2353',
          status: 'SHIPPED',
          supplier_id: 'CNPJ',
        },
        shipping: {
          date: '',
          tracking: {
            company: '',
            number: '',
          },
        },
        invoice: {
          danfe: 'base64(string)',
          nf_xml: 'xml(string)',
        },
      },
    ],
  },
  getOrder: {
    url: 'https://integration.inventa.tec.br/orders/order-id',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Auth: 'api-key-sent-to-supplier',
    },
  },
  searchOrderbyCreatedAtDate: {
    url: 'https://api.inventa.dev.br/orders?supplier_id=CNPJ&created_at=2022-06-22',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Auth: 'api-key-sent-to-supplier',
    },
  },
  searchOrderbyUpdatedAtDate: {
    url: 'https://api.inventa.dev.br/orders?supplier_id=CNPJ&updated_at=2022-06-22',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Auth: 'api-key-sent-to-supplier',
    },
  },
};
